import ApolloClient from 'apollo-boost'

import { useNotificationStore } from './store'

export default new ApolloClient({
  uri: process.env.VUE_APP_GRAPHQL_ENDPOINT,
  headers: {
    'x-hasura-admin-secret': process.env.VUE_APP_HASURA_ADMIN_SECRET,
  },
  onError: (err) => {
    if (err.networkError) {
      if (err.networkError.message) {
        useNotificationStore().addNotification(
          'The connection is unstable at this time, please try agian later',
          'is-warning'
        )
      }
    } else if (err.graphQLErrors) {
      err.graphQLErrors.forEach(({ message }) =>
        useNotificationStore().addNotification(`Error: ${message}`, 'is-danger')
      )
    } else {
      useNotificationStore().addNotification(
        'An unknown error has occured, please try again later',
        'is-danger'
      )
    }
  },
})
